import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, input } from '@angular/core';
import { ToolbarModule } from 'primeng/toolbar';
import { BlockGridComponent } from '../block-grid/block-grid.component';
import { ButtonModule } from 'primeng/button';
import { AdminNavbarItemComponent } from '../admin-navbar-item/admin-navbar-item.component';
import { NavItem } from '../admin-navbar/admin-navbar.component';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-toolbar',
  standalone: true,
  imports: [CommonModule, ToolbarModule, ButtonModule, BlockGridComponent, AdminNavbarItemComponent, RouterModule],
  templateUrl: './toolbar.component.html',
  styleUrl: './toolbar.component.scss'
})
export class ToolbarComponent {

  @Input() pageTitle: string = '';
  @Input() pageSubTitle: string = '';
  @Input() buttonItems: NavItem[] = []
  
 
}
